import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { FilePutPayload } from 'Services/AWS';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction(async (payload: FilePutPayload) =>
    $actions.user.putRequisite(dispatch, payload),
  );
};
